import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Helmet from "react-helmet"

function SEO({
  description,
  lang,
  meta,
  title,
  shareImage,
  titleTemplate,
  pagePath,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            assetPrefix
            title
            description
            author
            userTwitter
            shareImage
            siteUrl
          }
        }
      }
    `
  )

  let ogImage =
    site.siteMetadata.siteUrl +
    site.siteMetadata.assetPrefix +
    site.siteMetadata.shareImage

  let pageUrl = site.siteMetadata.siteUrl

  const metaDescription = description || site.siteMetadata.description

  // Add base url if it's not included in the path
  if (shareImage) {
    ogImage = new URL(`${shareImage}`, site.siteMetadata.siteUrl).toString()
  }

  if (titleTemplate === undefined) {
    titleTemplate = `%s | ${site.siteMetadata.title}`
  }

  if (pagePath) {
    pageUrl = site.siteMetadata.siteUrl + pagePath
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={titleTemplate}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        { property: `og:url`, content: pageUrl },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:site`,
          content: `@karbonhq`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.userTwitter,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: ogImage,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  titleTemplate: PropTypes.string,
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  shareImage: PropTypes.string,
}

export default SEO
